import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AreasPage = lazy(() => import('../pages/areas/page'));
const SuburbPage = lazy(() => import('../pages/areas/SuburbPage'));
const MilperraProjectPage = lazy(() => import('../pages/portfolio/milperra/page'));
const CronullaProjectPage = lazy(() => import('../pages/portfolio/cronulla/page'));
const GregoryHillsProjectPage = lazy(() => import('../pages/portfolio/gregory-hills/page'));
const PeakhurstProjectPage = lazy(() => import('../pages/portfolio/peakhurst/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const FullBathroomRenovationsPage = lazy(() => import('../pages/services/full-bathroom-renovations/page'));
const DemolitionPage = lazy(() => import('../pages/services/demolition/page'));
const PlumbingPage = lazy(() => import('../pages/services/plumbing/page'));
const ElectricalPage = lazy(() => import('../pages/services/electrical/page'));
const WaterproofingPage = lazy(() => import('../pages/services/waterproofing/page'));
const TilingRenderingPage = lazy(() => import('../pages/services/tiling-rendering/page'));
const VillaBoardPage = lazy(() => import('../pages/services/villa-board/page'));
const ThankYouPage = lazy(() => import('../pages/thank-you/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/services/full-bathroom-renovations',
    element: <FullBathroomRenovationsPage />,
  },
  {
    path: '/services/demolition',
    element: <DemolitionPage />,
  },
  {
    path: '/services/plumbing',
    element: <PlumbingPage />,
  },
  {
    path: '/services/electrical',
    element: <ElectricalPage />,
  },
  {
    path: '/services/waterproofing',
    element: <WaterproofingPage />,
  },
  {
    path: '/services/tiling-rendering',
    element: <TilingRenderingPage />,
  },
  {
    path: '/services/villa-board',
    element: <VillaBoardPage />,
  },
  {
    path: '/portfolio',
    element: <PortfolioPage />,
  },
  {
    path: '/portfolio/milperra',
    element: <MilperraProjectPage />,
  },
  {
    path: '/portfolio/cronulla',
    element: <CronullaProjectPage />,
  },
  {
    path: '/portfolio/gregory-hills',
    element: <GregoryHillsProjectPage />,
  },
  {
    path: '/portfolio/peakhurst',
    element: <PeakhurstProjectPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/areas',
    element: <AreasPage />,
  },
  {
    path: '/areas/:slug',
    element: <SuburbPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/thank-you',
    element: <ThankYouPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
